<div class="pl-calendar-header">
  <button
    mat-button
    type="button"
    class="pl-calendar-header-label"
    (click)="openMonthView()"
  >
    {{ periodLabel }}
  </button>
  <button
    mat-icon-button
    class="pl-calendar-header-prev"
    (click)="previousClicked(currentView)"
  >
    <mat-icon> chevron_left </mat-icon>
  </button>
  <button mat-icon-button (click)="nextClicked(currentView)">
    <mat-icon> chevron_right </mat-icon>
  </button>
</div>
